export const T = {
  en_GB: {
    clientCardDisplay: "Client Card Display",
    clientCardDescription:
      'Select up to 3 date fields to display below the client name on client cards. Dates will be shown as "X days ago".',
    settingsSaved: "Saved",
    selectedCount: (count: string) => `Selected: ${count}/3`,
    save: "Save",
    failedToSaveSettings: "Failed to save settings",
  },
  nb_NO: {
    clientCardDisplay: "Kundekortvisning",
    clientCardDescription:
      'Velg opptil 3 datofelt som skal vises under kundenavnet på kundekort. Datoer vises som "X dager siden".',
    settingsSaved: "Lagret",
    selectedCount: (count: string) => `Valgt: ${count}/3`,
    save: "Lagre",
    failedToSaveSettings: "Kunne ikke lagre innstillinger",
  },
} as const;

export const ACTIVITY_DATE_LABELS = {
  en_GB: {
    lastLogin: "Last Login",
    lastInfoUpdated: "Last Updated",
    lastFlowActivity: "Last Flow Activity",
    lastFlowCompleted: "Last Flow Completed",
    lastAccountSynced: "Last Account Synced",
    lastSignedDocument: "Last Signed Document",
    createdAt: "Created",
  },
  nb_NO: {
    lastLogin: "Siste innlogging",
    lastInfoUpdated: "Sist oppdatert",
    lastFlowActivity: "Siste flytaktivitet",
    lastFlowCompleted: "Siste fullførte flyt",
    lastAccountSynced: "Siste kontosynkronisering",
    lastSignedDocument: "Siste signerte dokument",
    createdAt: "Opprettet",
  },
} as const;
